import { Typography } from '@mui/material';
import { T } from '@tolgee/react';
import { NotificationList } from '../NotificationList';
import { NotificationsTabProps } from './types';

export const AllNotificationsTab = ({
  items,
  onClose,
}: NotificationsTabProps) => (
  <>
    {items.at(0)?.status === 'unread' && (
      <Typography
        variant="subtitle2"
        sx={{ color: 'text.secondary', px: 2, py: 1.5 }}
      >
        <T keyName="shared.buttons.new" />
      </Typography>
    )}
    <NotificationList items={items} onClose={onClose} />
  </>
);
